import { Button, Container, Input } from './styles';

export const StyledUploadFile = () => (
  <Container>
    <Input value="Anexar arquivo (.JPG .JPEG .PNG .PDF .DOC)" disabled />
    <Button type="button">Escolher arquivo</Button>
  </Container>
);
